import { useTranslation } from "react-i18next";

interface ValidationProps {
  headerMsg: string;
  onYesClick: Function;
  onNoClick: Function;
}

export function YesNoComponent(props: ValidationProps) {
  const { t } = useTranslation();

  return (
    <div className="container page">
      <div className="col-12 col-xl-6 offset-xl-3">
        <div className="card">
          <div className="card-header align-items-center">
            <div className="d-inline-block">
              <h2>{props.headerMsg}</h2>{" "}
            </div>
          </div>
          <div className="card-body">
            <div className="align-items-center">
              <button className="btn btn-outline-primary me-2" onClick={() => props.onYesClick()}>
                {t("common.yes")}
              </button>

              <button className="btn btn-outline-primary me-2" onClick={() => props.onNoClick(false)}>
                {t("common.no")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
